import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import ReactDOM from 'react-dom/client';
import App from '@app/index';
import apolloClientConfig from '@configs/apollo-client-config';
import reportWebVitals from '@configs/report-web-vitals';

// This library is needed to enable dynamic iframe resizing, enables iframe to communicate w/ parent window
import 'iframe-resizer/js/iframeResizer.contentWindow';
import 'react-datepicker/dist/react-datepicker.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClientConfig}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
